<template>
   <div class="layout-header">
        <div class="left-header">
            <!-- 闭合菜单按钮 -->
            <Vicon class="trigger" v-if="collapsed" @click="$emit('update:collapsed', !collapsed)" :icon="'indent-increase'"/>
        
            <Vicon class="trigger" v-if="!collapsed" @click="$emit('update:collapsed', !collapsed)" :icon="'indent-decrease'"/>
            
            <div class="left-header-title">碳中和评级系统</div>
        </div>

        <div class="right-header">

            <!-- <a-button @click="changeColor">主题</a-button> -->

            <!-- 个人中心 -->
            <div class="flex">
                <Vicon :icon="'user-3-line'" class="noti"/>
                <div class="txt">{{userInfo?.nickname}}</div>
            </div>

            <!-- 分割线 -->
            <div class="drawp"></div>

            <!-- 登出 -->
            <div class="flex" @click="goToLogin">
                <Vicon :icon="'logout-circle-r-line'" class="noti"/>
                <div class="txt">退出登录</div>
            </div>
        </div>
        
   </div>
   <div class="layout-bread">
        <a-breadcrumb>
            <!-- <a-breadcrumb-item v-if="route.path !== '/'">
                <a  @click.prevent="handleLinkHome()">首页</a>
            </a-breadcrumb-item> -->
            <a-breadcrumb-item v-for="(item,index) in levelList" :key="index">
                <a  @click.prevent="handleLink(item)">{{item.meta.title}}</a>
            </a-breadcrumb-item>
        </a-breadcrumb>
   </div>
</template>

<script>
import { MenuUnfoldOutlined,MenuFoldOutlined, } from '@ant-design/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import { defineComponent,ref, watch, computed, onMounted, onUnmounted, onBeforeMount } from "vue"
import Vicon from '../icon/index.vue'
import authority from '@/api/authority';
import { useLoginStore } from '@/store/login'
export default defineComponent({
    name:'layoutHeader',
    components: {
        MenuUnfoldOutlined,
        MenuFoldOutlined,
        Vicon
    },
    emits: ['update:collapsed'],
    props: {
        collapsed: {
            required: true,
            type: Boolean
        },
    },
    setup(props){
        const route = useRoute()
        const router = useRouter()
        //引入数据管理库
        const LoginStore = useLoginStore()
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        const show = ref(false)
        const levelList = computed(() => {
            return route.matched.filter(item => item.meta && item.meta.title)
        })
        watch(() => route, (value) =>{
            return levelList
        },{immediate: true})
        const handleLink = (item) =>{
            const {redirect, path} = item
            if(redirect){
                router.push(redirect)
                return
            }
            if(path == route.path){
                router.go(0)
            }else{
                router.push(path)
            }
        }
        const handleLinkHome = () => {
            router.push('/')
        }
        
        onBeforeMount(() => {})
        const changeColor = () => {
            window.less.modifyVars({
                "@layout-sider-background": "#2B3139",
                "@menu-bg":"#2B3139",
                "@menu-popup-bg":"#2B3139",
                "@menu-item-color":"#FFFFFF",
            })
            .then((res) => {
                console.log('成功')
            })
            .catch((err) => {
                console.log('失败')
            })
        }

        //退出登录
        const goToLogin = () => {
            authority.clearToken()
            sessionStorage.removeItem('userInfo')
            sessionStorage.removeItem('token')
            localStorage.removeItem('locale')
            router.push('/login')
        }
        return {
            show,
            levelList,
            changeColor,
            goToLogin,
            LoginStore,
            userInfo,
            handleLink,
            handleLinkHome,
            route
        }
    }
})
</script>
<style scoped lang='less'>
.layout-header{
    height: 100%;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    color:#a9a9a9;
    font-weight: 600;
    .left-header{
        height: 100%;
        display: flex;
        align-items: center;
        flex-grow: 1;
        .left-header-title{
            margin-left: 25px;
            font-size: 20px;
            // font-family: PingFang SC, Arial, Microsoft YaHei, sans-serif;
            font-weight: 600;
            color: #00142A;
            
            .font-w{
                font-weight: 600;
                color: #000000;
            }
        }
    }
    .right-header{
        height: 100%;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        flex-grow: 0;
        .flex{
            display: flex;
            align-items: center;
            cursor: pointer;
            .txt{
                font-size: 14px;
                font-weight: 600;
                color: #00142A;
                line-height: 20px;
                margin-left: 8px;
            }
        }
        .noti{
            font-size: 20px;
            color: #00142A;
            font-weight: 600;
        }
        .drawp{
            width: 1px;
            height: 41px;
            background-color: #E9E9E9;
            margin: 0 30px;
        }
        .avatar-img{
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: #9a999c;
        }
        .name{
            margin-left: 15px;
            font-size: 14px;
            // font-family: PingFang SC, Arial, Microsoft YaHei, sans-serif;
            font-weight: 400;
            color: #00142A;
        }
    }
}
.layout-bread{
    margin: 20px 0;
    .ant-breadcrumb{
        // font-family: PingFang SC, Arial, Microsoft YaHei, sans-serif;
        font-weight: 400;
    }
}
.trigger{
    cursor: pointer;
}
.ant-breadcrumb a:hover{
    color: rgba(0, 0, 0, 0.45);
}
</style>